<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div
	class="toast-container"
	[ngClass]="data.type"
>
	<div class="toast-header">
		<span [ngClass]="'icon-' + iconName"></span>
		<span class="toast-title">{{ data.title }}</span>
		<button
			class="toast-close"
			(click)="dismiss()"
			aria-label="Dismiss notification"
		>
			<span>⨉</span>
		</button>
	</div>

	@if (data.message) {
		<p class="toast-message">{{ data.message }}</p>
	}

	<div class="toast-progress">
		<div
			class="toast-progress-bar"
			[style.animation-duration.ms]="data.duration"
		></div>
	</div>
</div>
